import { jsPDF } from "jspdf";

const SECTIONS = [
  ["word_overview", "Word / Name Overview"],
  ["litraroot", "Litraroot"],
  ["litracharge", "Litracharge"],
  ["litrabonds", "Litrabonds"],
  ["litrasequence", "Litrasequence"],
  ["litraframe", "Litraframe"],
  ["litraseal", "Litraseal"],
  ["wordbody", "Wordbody"],
  ["vowel_field", "Vowel Field"],
  ["consonant_engine", "Consonant Engine"],
  ["repetition_pattern", "Repetition Pattern"],
  ["word_class", "Word Class"],
  ["status_signal", "Status Signal"],
  ["archetype_signal", "Archetype Signal"],
  ["shadow_pattern", "Shadow Pattern"],
  ["brand_identity_use", "Brand / Identity Use"],
  ["suggested_taglines", "Suggested Taglines"],
  ["suggested_content_angles", "Suggested Content Angles"],
  ["final_litrabind_statement", "Final Litrabind Statement"],
  ["shareable_card_text", "Shareable Card Text"],
  ["missions_unlocked", "Missions Unlocked"],
];

const C = {
  bg: [11, 12, 14],
  bone: [244, 241, 234],
  muted: [169, 163, 154],
  green: [46, 158, 118],
  gold: [201, 162, 75],
  faint: [120, 116, 110],
  line: [55, 58, 62],
};

export function exportReportPdf(report, inputText) {
  if (!report) return;
  const pdf = new jsPDF({ unit: "pt", format: "a4" });
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  const margin = 48;
  const contentW = pw - margin * 2;
  let y = margin;

  const paintBg = () => { pdf.setFillColor(C.bg[0], C.bg[1], C.bg[2]); pdf.rect(0, 0, pw, ph, "F"); };
  const ensure = (need) => { if (y + need > ph - margin) { pdf.addPage(); paintBg(); y = margin; } };

  paintBg();
  pdf.setTextColor(C.green[0], C.green[1], C.green[2]);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);
  pdf.text("LITRAMETRY", margin, y); y += 20;
  pdf.setTextColor(C.bone[0], C.bone[1], C.bone[2]);
  pdf.setFontSize(20);
  pdf.text("Full Litrametry Report", margin, y); y += 24;
  pdf.setTextColor(C.gold[0], C.gold[1], C.gold[2]);
  pdf.setFontSize(14);
  pdf.text(String(inputText || ""), margin, y); y += 12;
  pdf.setDrawColor(C.line[0], C.line[1], C.line[2]);
  pdf.line(margin, y, pw - margin, y); y += 22;

  SECTIONS.forEach(([key, title], i) => {
    const value = report[key];
    if (value == null || value === "") return;
    ensure(44);
    pdf.setTextColor(C.green[0], C.green[1], C.green[2]);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.text(`${String(i + 1).padStart(2, "0")}   ${title.toUpperCase()}`, margin, y); y += 16;
    pdf.setTextColor(C.muted[0], C.muted[1], C.muted[2]);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(10.5);
    const isList = Array.isArray(value);
    const items = isList ? value : [value];
    items.forEach((v) => {
      const prefix = isList ? "\u2022  " : "";
      const lines = pdf.splitTextToSize(prefix + String(v), contentW);
      lines.forEach((ln) => { ensure(16); pdf.text(ln, margin, y); y += 14; });
      if (isList) y += 2;
    });
    y += 12;
  });

  if (report.disclaimer) {
    ensure(48);
    pdf.setDrawColor(C.line[0], C.line[1], C.line[2]);
    pdf.line(margin, y, pw - margin, y); y += 16;
    pdf.setTextColor(C.faint[0], C.faint[1], C.faint[2]);
    pdf.setFont("helvetica", "italic");
    pdf.setFontSize(8.5);
    pdf.splitTextToSize(report.disclaimer, contentW).forEach((ln) => { ensure(12); pdf.text(ln, margin, y); y += 11; });
  }

  pdf.save(`litrametry-report-${String(inputText || "word").replace(/\s+/g, "-").toLowerCase()}.pdf`);
}

export async function exportNodePdf(dataUrl, imgWidth, imgHeight, filename) {
  const orientation = imgWidth >= imgHeight ? "landscape" : "portrait";
  const pdf = new jsPDF({ orientation, unit: "pt", format: "a4" });
  const pw = pdf.internal.pageSize.getWidth();
  const phh = pdf.internal.pageSize.getHeight();
  pdf.setFillColor(C.bg[0], C.bg[1], C.bg[2]);
  pdf.rect(0, 0, pw, phh, "F");
  const margin = 36;
  const maxW = pw - margin * 2;
  const ratio = imgHeight / imgWidth;
  let w = maxW;
  let h = w * ratio;
  if (h > phh - margin * 2) { h = phh - margin * 2; w = h / ratio; }
  const x = (pw - w) / 2;
  const yy = (phh - h) / 2;
  pdf.addImage(dataUrl, "PNG", x, yy, w, h);
  pdf.save(filename);
}
